module.exports = __webpack_public_path__ + "img/clogo.5ee84134.png";